/**
 * ドメインエラー基底クラス
 *
 * ドメイン層で発生するすべてのエラーの基底クラス
 */
export abstract class DomainError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;

    // プロトタイプチェーンの修正（TypeScript継承の問題対応）
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
